{
  "basicTerms": {
    "selectedOfTotal": "{selected}/{total} Selected",
    "search": "Search",
    "summary": "Summary",
    "insights": "Insights",
    "help": "Help",
    "expand": "Expand",
    "collapse": "Collapse",
    "menu": "Menu",
    "account": "Account",
    "logout": "Log Out",
    "signIn": "Sign In",
    "days": "Day | Days",
    "phone": "Phone",
    "subscribers": "Subscriber | Subscribers",
    "favorites": "Favorite | Favorites",
    "others": "Other | Others",
    "yes": "Yes",
    "no": "No",
    "locations": "Location | Locations",
    "active": "Active",
    "inactive": "Inactive",
    "all": "All",
    "view": "View",
    "language": "Language",
    "required": "Required",
    "timezone": "Timezone",
    "new": "New",
    "open": "Open",
    "close": "Close",
    "closed": "Closed",
    "occupied": "Occupied",
    "reserved": "Reserved",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "enable": "Enable",
    "disable": "Disable",
    "print": "Print",
    "download": "Download",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "previous": "Previous",
    "next": "Next",
    "version": "Version",
    "setup": "Setup",
    "caution": "Caution",
    "notes": "Note | Notes",
    "add": "Add",
    "remove": "Remove",
    "duration": "Duration",
    "link": "Link",
    "unlink": "Unlink",
    "to": "To",
    "success": "Success",
    "error": "Error",
    "info": "Info",
    "warning": "Warning",
    "time": "Time",
    "saved": "Saved",
    "forms": "Form | Forms",
    "is": "is",
    "only": "Only",
    "saving": "Saving",
    "text": "text",
    "zip": "zip",
    "spreadsheet": "spreadsheet",
    "image": "Image",
    "cloning": "Cloning",
    "clone": "Clone",
    "added": "Added",
    "removed": "Removed",
    "planned": "Planned",
    "unplanned": "Unplanned",
    "checkedIn": "Checked In",
    "checkedOut": "Checked Out",
    "more": "More",
    "okay": "Okay",
    "reschedule": "Reschedule",
    "results": "Result | Results",
    "none": "None",
    "pages": "Page | Pages",
    "pageOfTotal": "Page {current} of {total}",
    "of": "of",
    "default": "Default",
    "soon": "soon",
    "grid": "Grid",
    "list": "List",
    "booked": "Booked",
    "arrivals": "Arrival | Arrivals",
    "early": "Early",
    "late": "Late",
    "onTime": "On Time",
    "area": "Area | Areas",
    "spot": "Spot",
    "single": "Single",
    "multiple": "Multiple",
    "filter": "Filter",
    "board": "Board",
    "at": "at",
    "from": "From",
    "recent": "Recent",
    "delivered": "Delivered",
    "sent": "Sent",
    "create": "Create",
    "tasks": "Task | Tasks",
    "emails": "Email | Emails",
    "passwords": "Password | Passwords",
    "limits": "Limits",
    "assignee": "Assignee",
    "comment": "Comment",
    "issue": "Issue",
    "urgent": "Urgent",
    "retry": "Retry",
    "custom": "Custom",
    "na": "N/A"
  },
  "phrases": {
    "copyToClipboard": "Copy to Clipboard",
    "copiedToClipboard": "Copied to Clipboard",
    "warehouseAddress": "Warehouse address",
    "cloneSchedule": "Clone Schedule",
    "open24Hours": "Open 24 Hours",
    "featureEnabled": "Feature Enabled",
    "featureDisabled": "Feature Disabled",
    "learnMore": "Learn more",
    "minuteLabel": "{minutes} MIN",
    "minuteLabelFull": "{minutes} minutes",
    "thisActionCannotBeUndone": "this action CANNOT be undone",
    "areYouSure": "Are you sure?",
    "unknownUser": "Unknown user",
    "leaveWithoutSaving": "Leave Without Saving",
    "learnHowItWorks": "Learn how it works",
    "allFields": "All Fields",
    "selectColumns": "Select columns",
    "selectedColumns": "Selected columns",
    "addFiles": "Add file | Add files",
    "tasks": "No tasks | {count} task | {count} tasks",
    "driversSelfCheckin": "Driver’s self check-in",
    "addReferenceNumber": "Add reference number",
    "myAccount": "My Account"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "The confirmation field does not support pasting",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "You may have unsaved changes, are you sure you want to leave this page?",
    "browserDoesNotSupportCopyFunction": "Browser does not support copy function",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "Permission to access clipboard was denied. To enable access, update your browser settings.",
    "alternativelyYouCanManuallyCopy": "Alternatively, you can manually copy",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "Are you sure you want to leave? You may have unsaved changes.",
    "noResultsFound": "No results found",
    "maximumOfReferenceNumbersAllowedCountRemoved": "Maximum of {maxItems} reference numbers allowed. {removedCount} removed"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "Warehouse | Warehouses",
    "carrierContacts": "Carrier Contact | Carrier Contacts",
    "loadTypes": "Load Type | Load Types",
    "docks": "Dock | Docks",
    "appointments": "Appointment | Appointments",
    "users": "User | Users",
    "organizations": "Organization | Organizations",
    "orgs": "Org | Orgs",
    "companies": "Company | Companies",
    "referenceNumber": "Reference Number",
    "refNumber": "Reference Number",
    "status": "Status",
    "orgLoadTypes": "Org Load Types",
    "schedulingPortal": "Scheduling Portal",
    "customFields": "custom field | custom fields",
    "interval": "Interval",
    "drivers": "Driver | Drivers",
    "carriers": "Carrier | Carriers",
    "tags": "Tag | Tags",
    "yardManagement": "Yard Management",
    "carrier": "carrier | carriers",
    "assets": "Asset | Assets",
    "tvMode": "TV Mode",
    "gridView": "Grid View",
    "listView": "List View",
    "gateManagement": "Gate Management",
    "selfCheckIn": "self-check in",
    "gateFeed": "Gate Feed"
  },
  "appointmentStatuses": {
    "NoShow": "No Show",
    "Cancelled": "Cancelled",
    "Requested": "Requested",
    "Scheduled": "Scheduled",
    "Arrived": "Arrived",
    "InProgress": "In Progress",
    "Completed": "Completed",
    "Reserves": "Reserves"
  },
  "appointmentTypes": {
    "standard": "Standard",
    "reserved": "Reserved",
    "reserve": "Reserve"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "Warehouse User",
    "carrier": "Carrier"
  },
  "roles": {
    "base": "Base",
    "carrier": "Carrier",
    "carrierAdmin": "Carrier Admin",
    "spectator": "Spectator",
    "attendant": "Attendant",
    "operator": "Operator",
    "admin": "Admin",
    "owner": "Owner",
    "internal": "Internal",
    "god": "God"
  },
  "weekdays": {
    "sunday": "Sunday",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday"
  },
  "weekdaysAbbr": {
    "sun": "Sun",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat"
  },
  "buttons": {
    "nevermind": "Nevermind",
    "select": "Select",
    "confirm": "Confirm",
    "next": "Next",
    "previous": "Previous",
    "create": "Create",
    "edit": "Edit",
    "save": "Save",
    "send": "Send",
    "yesDelete": "Yes, Delete",
    "skipCreation": "Skip Creation",
    "cancel": "Cancel",
    "export": "Export",
    "saveChanges": "Save changes",
    "exportData": "Export data",
    "resetToDefault": "Reset to Default"
  },
  "tooltips": {
    "notAvailable": "Not Available",
    "notAvailableForUserRole": "Not available for your user role."
  },
  "errors": {
    "unkownError": "An unknown error occurred.",
    "thisFieldIsRequired": "This field is required",
    "passwordDoesNotMeetRequirements": "Password does not meet password requirements",
    "emailMustBeValid": "Email must be valid",
    "pleaseEnterAValidPhoneNumber": "Please enter a valid phone number",
    "pleaseEnterAValidUrl": "Please enter a valid URL",
    "invalidHour": "Invalid Hour",
    "invalidMinute": "Invalid Minute",
    "pleaseSelectAmOrPm": "Select AM or PM",
    "pleaseEnterACompleteDateAndTime": "Enter a complete date and time",
    "mustBeANumber": "Must be a number",
    "mustBeAPositiveInteger": "Must be a positive integer",
    "mustBeAWholeNumber": "Must be a whole number",
    "isNotAValidNumber": "is not a valid number",
    "invalidUuid": "Invalid uuid",
    "dateMustNotBeInThePast": "Date must not be in the past",
    "mustBeWithin24HoursOfStartTime": "must be within 24 hours of start time",
    "pleaseSelectAtLeast": "Please select at least {requiredCount} {itemName} | Please select at least {requiredCount} {itemName}s",
    "cannotSelectMoreThan": "Cannot select more than {limit} {itemName} | Cannot select more than {limit} {itemName}s",
    "fieldMustEqual": "Field must equal {value}",
    "mustBeXCharacters": "Must be {length} character | Must be {length} characters",
    "mustBeAtLeastXCharacters": "Must be at least {min} character long | Must be at least {min} characters long",
    "mustBeAtMostXCharacters": "Must be at most {max} character long | Must be at most {max} characters long",
    "mustBeBetweenXAndYCharactersLong": "Must be between {min} and {max} characters long",
    "mustBeNumberBetweenXAndY": "Must be a number between {min} and {max}",
    "mustBeNumberGreaterThan": "Must be a number greater than or equal to {min}",
    "mustBeNumberLessThan": "Must be a number less than {max}",
    "mustHaveAtLeast8Characters": "Must have at least 8 characters",
    "mustContainUpperCaseAndLowerCase": "Must contain upper-case and lower-case",
    "mustContainAtLeastOneLetter": "Must contain at least one letter",
    "mustContainAtLeastOneSpecialCharacter": "Must contain at least one special character",
    "mustContainAtLeastOneNumber": "Must contain at least one number",
    "atLeastOneReferenceNumberIsRequired": "At least one {refNumberDisplayName} is required",
    "mustBeAValidNumber": "Must be a valid number"
  },
  "warehouseAmenities": {
    "lumperServices": "Lumper services",
    "overnightParking": "Overnight parking",
    "driversRestroom": "Drivers restroom",
    "freeWiFi": "Free Wi-Fi"
  },
  "warehousePPERequirements": {
    "safetyBoots": "Safety Boots",
    "safetyGlasses": "Safety Glasses",
    "gloves": "Gloves",
    "hardHat": "Hard Hat",
    "faceMask": "Face Mask",
    "noSmoking": "No Smoking",
    "longPants": "Long Pants",
    "longSleeves": "Long Sleeves",
    "highVisibilityVest": "High Visibility Vest",
    "hairAndBeardNet": "Hair and Beard Net"
  },
  "auditLog": {
    "header": "Audit Log",
    "viewAuditLog": "View Audit Log",
    "noAuditLogEvents": "No audit log events",
    "timelineForAllUpdatesMadeToThis": "Timeline for all updates made to this",
    "hasTheWords": "has the words",
    "eventsFromDate": "Events from date",
    "searchEvents": "Search Events",
    "by": "by",
    "appointmentUpdatesTimeline": "Appointment updates timeline:",
    "moreUpdates": "{count} more updates",
    "emailSubscribersUpdated": "Email Subscribers Updated",
    "detailsUpdated": "Details Updated",
    "recurrenceCreated": "Recurrence Created",
    "recurrenceDeleted": "Recurrence Deleted",
    "rescheduled": "{label} Rescheduled",
    "etaUpdated": "ETA Updated",
    "emailNotifications": "Email notifications",
    "carrierContactUpdated": "Carrier Contact Updated",
    "reserveTransferred": "Reserve Transferred",
    "tagsUpdated": "Tags Updated",
    "scheduled": "{label} Scheduled",
    "statusUpdated": "Status Updated",
    "timeUpdated": "{arrived} Time Updated",
    "dwellTimeUpdated": "Dwell Time Updated",
    "everyXAtXUntilX": "Every {weekDays} {'@'} {endTime} until {endDate}",
    "opendockTeam": "Opendock Team",
    "unknownUser": "Unknown User",
    "deleted": "Deleted",
    "hasBeenCleared": "has been cleared",
    "actionUpdated": "updated",
    "actionCreated": "Created",
    "actionDeleted": "Deleted",
    "noAction": "No action",
    "emptyValue": "Empty value"
  },
  "timeline": {
    "createdTheTask": "created the task",
    "startedTheTask": "started the task",
    "blockedTheTask": "blocked the task",
    "unblockedTheTask": "unblocked the task",
    "completedTheTask": "completed the task",
    "cancelledTheTask": "cancelled the task",
    "cancelledTheReserve": "cancelled the reserve",
    "cancelledTheReservationForSpot": "cancelled the reservation for {areaName} - {spotCode} for this task",
    "reservedSpotForThisTask": "reserved {areaName} - {spotCode} for this task",
    "reservedTheSpot": "reserved the spot",
    "reason": "Reason: {reason}",
    "addedA": "added a",
    "reportedAn": "reported an",
    "clearedThe": "cleared the",
    "flaggedTheTask": "flagged the task",
    "flaggedTheTaskAs": "flagged the task as",
    "unflaggedTheTask": "unflagged the task",
    "unflaggedTheTaskAs": "unflagged the task as",
    "updatedTheTask": "updated the task",
    "removedTask": "removed task",
    "attachments": "attachments",
    "confirmedTheLocation": "confirmed the location",
    "reportedAsMissing": "reported as missing",
    "noActivityYet": "No activity yet",
    "noAssignee": "No assignee",
    "failedToFetchYardTaskTimeline": "Failed to fetch yard task timeline",
    "failedToCreateComment": "Failed to create comment"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "{action} this Spot?"
    },
    "dropDownItems": {
      "cleaning": "Cleaning",
      "underMaintenance": "Under Maintenance",
      "blockedByEquipment": "Blocked by Equipment",
      "safetyInspection": "Safety Inspection",
      "routineInspection": "Routine Inspection",
      "reserved": "Reserved",
      "repairsNeeded": "Repairs Needed",
      "damage": "Damage"
    },
    "labels": {
      "reason": "Reason",
      "additionalNotes": "Additional Notes"
    },
    "placeholders": {
      "selectAReason": "Select a reason",
      "enterAdditionalNotes": "Enter additional notes"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "This spot will remain unavailable for asset assignment until it is set as open again.",
      "thisDoorWillBeSetAsOpen": "This door will be set as open and will be available again for asset assignment.",
      "assetInTransitClosingWillBlockMove": "Asset {assetCode} is currently in transit to this spot. Closing it will block the move from being completed."
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "Unassigned",
      "noDueDate": "No due date",
      "fromAnySpot": "From any spot",
      "toAnySpot": "To any spot",
      "anyAsset": "Any asset",
      "types": {
        "move": "Move"
      },
      "status": {
        "toDo": "To Do",
        "inProgress": "In Progress",
        "completed": "Completed",
        "canceled": "Canceled"
      },
      "issue": "Issue",
      "relatedEntity": {
        "spotArea": "Area",
        "spot": "Spot",
        "asset": "Asset"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "Ready for Pickup Notification",
    "messages": {
      "body": "Send an email to the following contacts informing that asset {assetContainerCode} is ready for pickup at {warehouseName}.",
      "notificationSent": "Notification sent successfully.",
      "notificationFailed": "Failed to send notification. Please try again."
    },
    "labels": {
      "notifyTheseContacts": "Notify these contacts:",
      "suggestedContacts": "Suggested contacts:"
    },
    "buttons": {
      "skipNotification": "Skip Notification"
    }
  }
}
